import type { GuidebookStrategy, GuidebookHouseRules } from "./types"

interface Props {
  strategy?: GuidebookStrategy | null
  houseRules: GuidebookHouseRules
  checkinTime?: string
}

export function ArrivalDepartureSection({ strategy, houseRules, checkinTime }: Props) {
  const checkoutTime = houseRules.checkout?.checkoutTime
  const checklist = houseRules.checkout?.checklist || []

  const hasRows = Boolean(strategy?.check_in || strategy?.check_out || checkinTime || checkoutTime || strategy?.summary)
  if (!hasRows && checklist.length === 0) return null

  return (
    <div className="gb-section">
      <h2 className="gb-section__title">Your stay</h2>
      <div className="gb-card">
        {hasRows && (
          <div className="gb-arrival__plan">
            {strategy?.check_in && (
              <div className="gb-arrival__plan-row">
                <span className="gb-arrival__plan-label">Arrival</span>
                <span className="gb-arrival__plan-text">{formatDate(strategy.check_in)}</span>
              </div>
            )}
            {strategy?.check_out && (
              <div className="gb-arrival__plan-row">
                <span className="gb-arrival__plan-label">Departure</span>
                <span className="gb-arrival__plan-text">{formatDate(strategy.check_out)}</span>
              </div>
            )}
            {checkinTime && (
              <div className="gb-arrival__plan-row">
                <span className="gb-arrival__plan-label">Check-in</span>
                <span className="gb-arrival__plan-text">From {checkinTime}</span>
              </div>
            )}
            {checkoutTime && (
              <div className="gb-arrival__plan-row">
                <span className="gb-arrival__plan-label">Check-out</span>
                <span className="gb-arrival__plan-text">By {checkoutTime}</span>
              </div>
            )}
            {strategy?.summary && (
              <div className="gb-arrival__plan-row">
                <span className="gb-arrival__plan-label">Stay</span>
                <span className="gb-arrival__plan-text">
                  {strategy.nights} {strategy.nights === 1 ? "night" : "nights"}
                  {strategy.adults > 0 && ` · ${strategy.adults} ${strategy.adults === 1 ? "adult" : "adults"}`}
                  {strategy.children > 0 && ` · ${strategy.children} ${strategy.children === 1 ? "child" : "children"}`}
                </span>
              </div>
            )}
          </div>
        )}

        {checklist.length > 0 && (
          <>
            <h3 className="gb-card__title" style={{ marginTop: "0.5rem" }}>Departure checklist</h3>
            <ul className="gb-arrival__checklist">
              {checklist.map((item, index) => (
                <li key={index} className="gb-arrival__checklist-item">
                  <CheckIcon />
                  {item}
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  )
}

function formatDate(iso: string): string {
  try {
    const d = new Date(iso)
    return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "long" })
  } catch {
    return iso
  }
}

function CheckIcon() {
  return (
    <svg className="gb-arrival__checklist-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="8" cy="8" r="6" />
      <path d="M5.5 8l2 2 3-3.5" />
    </svg>
  )
}
